'use client';

import { c as _c } from "react/compiler-runtime";
import AppProvider from '@precis-digital/kurama/AppProviderNextjs';
import { type ReactElement } from 'react';
import Err500 from 'shared/components/Error/500';
import { LOCAL_STORAGE_KEYS } from 'shared/lstore';

/**
 * Replaces the root layout when an uncaught client error bubbles to Next.js.
 * Re-provides Kurama (root providers are unavailable here) and reuses the 500 page UI.
 */
export default function GlobalError(t0) {
  const $ = _c(3);
  const {
    error
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <head><title>Unexpected Error | Alvie</title></head>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== error) {
    t2 = <html lang="en">{t1}<body><AppProvider isThemeSwitchingEnabled={false} defaultThemePreference="system" themePreferenceStorageKey={LOCAL_STORAGE_KEYS.COLOUR_THEME_PREFERENCE}><Err500 error={error} /></AppProvider></body></html>;
    $[1] = error;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}